import type { TooltipProps } from 'react-tooltip';
import ReactTooltip from 'react-tooltip';
import { cx } from '../../../utils/cx';

export type ITooltipProps = TooltipProps;
/**
 * Internal ToolTip component, provides same api as ReactTooltip with useful defaults.
 * Can be overriden.
 *
 * Important Config:
 *
 * * delayShow: Add Time before the tooltip is shown (not to be confused with transition-duration).
 * * delayHide: Add Time before the tooltip is hidden.
 * * multiline: Pass `<br/>` and select elements as data-tip in a string and have it rendered.
 *              XSS worry: It seems no use of dangerouslySetInnerHTML, and some sanitisation occurs
 * * className: Adds to the existing list of classes
 * */
export function ITooltip(props: ITooltipProps) {
  const { children, className = '', ...rest } = props;

  const tooltip = cx(className, 'i__tooltip');

  return (
    <ReactTooltip
      className={tooltip}
      effect="solid"
      backgroundColor="#161A30"
      multiline
      {...rest}
    >
      {children}
    </ReactTooltip>
  );
}
